import { memo, useCallback } from 'react';

import { useWordEditor } from 'com/WordEditor';
import { MenuItem } from 'core/ui/Menu';
import { useMessageModal } from 'core/ui/MessageModal';
import ICONS from 'core/ui/icons';

type TProps = {
  wordUid: string;
  onUpdateWord: (word: TWord) => void;
};

const EditButton: React.FC<TProps> = ({ wordUid, onUpdateWord }) => {
  const { showError } = useMessageModal();
  const { editWord: openEditor } = useWordEditor();
  const onClick = useCallback(
    () =>
      openEditor(wordUid)
        .then(word => {
          if (word) return onUpdateWord(word);
        })
        .catch(showError),
    [wordUid, onUpdateWord, openEditor]
  );

  return <MenuItem label="Edit" icon={ICONS.Edit} onClick={onClick} kkb="F2" />;
};

export default memo(EditButton);
